import { environmentConfig } from "../environment";

export const SHIFT_INVITES_URL = `${environmentConfig.REACT_APP_API_MAIN_URL}/api/shift-invites`;
export const SHIFT_INVITES_VALIDATION_URL = `${SHIFT_INVITES_URL}/validate`;
